export enum RulesTaskBarItem {
  BUSINESS_RULES = 'business-rules',
  RULE_ASSOCIATIONS = 'rules-associations',
  ALERTS = 'alerts',
  RULES_VALUE_LIST = 'rules-value-lists',
}
